import { render, staticRenderFns } from "./KousakuWards.vue?vue&type=template&id=922f4160&scoped=true&"
import script from "./KousakuWards.vue?vue&type=script&lang=js&"
export * from "./KousakuWards.vue?vue&type=script&lang=js&"
import style0 from "./KousakuWards.vue?vue&type=style&index=0&id=922f4160&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922f4160",
  null
  
)

export default component.exports